<template>
  <div class="edit-address" v-r-loading="loading">
    <AlertTips
      v-model="showAlertTips"
      :type="alertType"
      :title="alertTitle"
      :showIcon="alertShowIcon"
    ></AlertTips>
    <div class="edit-infos">
      <div
        class="infos-display_name common-flex"
        @click="checkSelectPage"
        :class="{ 'finger-style': isBillLading }"
      >
        <div class="infos-display_name-text">{{ currentEditAddress }}</div>
        <i class="icon-outline_entrance" v-if="isShowRightIcon"></i>
      </div>
      <div class="infos-display_desc infos-display_name-text">
        {{ currentEditDesc }}
      </div>
      <div class="infos-type">{{ $t('补充详细地址信息') }}</div>
      <input type="text" readonly class="d-hide-input">
      <el-input
        class="el-input_d-reset"
        v-model="buildingNameVals"
        :placeholder="$t('公司/公寓名称')"
        :clearable="true"
      ></el-input>
      <input type="text" readonly class="d-hide-input">
      <el-input
        class="el-input_d-reset"
        v-model="houseNumberVals"
        :placeholder="$t('楼层/门牌号')"
        :clearable="true"
      ></el-input>
      <div class="infos-type">{{ $t('设为常用地点') }}</div>
      <div class="infos-type_text_content">
        <div
          v-for="item in addressType"
          :key="item.type"
          class="infos-type_text finger-style"
          :class="{
            'infos-type_text_active': item.type == currentTypeIndex,
          }"
          @click="clickCurrentType(item.type)"
        >
          {{ item.name }}
        </div>
      </div>
      <div v-if="isBillLading">
        <div class="infos-type">{{ $t('姓名') }}</div>
        <input type="text" readonly class="d-hide-input">
        <el-input
          class="el-input_d-reset"
          v-model="firstName"
          :placeholder="$t('名字')"
          :clearable="true"
        ></el-input>
        <el-input
          class="el-input_d-reset"
          v-model="lastName"
          :placeholder="$t('姓氏')"
          :clearable="true"
        ></el-input>
        <div class="infos-type">{{ $t('电话号码') }}</div>
        <div class="phone-class" :class="{ 'phone-class_err': isShowNoNumber }">
          <input type="text" readonly class="d-hide-input">
          <el-input
            class="calling-style el-input_d-reset"
            v-model="callingCode"
            @input="changeCalling"
            @blur="blurCalling"
          /><el-input
            class="el-input_d-reset"
            :placeholder="$t('电话号码')"
            v-model="phone"
            :clearable="true"
            oninput="value=value.replace(/[^\d]/g,'')"
          >
          </el-input>
        </div>
        <div class="err-tips" v-if="isShowNoNumber">
          {{ $t('请输入电话号码') }}
        </div>
      </div>
    </div>
    <div class="info-btn">
      <el-button
        dark
        outline
        @click="delAddress"
        v-if="selectType == 'listPage' && !isBillLading"
        >{{ $t('注销') }}</el-button
      >
      <el-button @click="createAddress">{{ $t('确定') }}</el-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import AlertTips from '../AlertTips';

export default {
  components: {
    AlertTips,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    typeName: {
      type: String,
      default: '',
      required: false,
    },
    selectType: {
      type: String,
      default: '',
      required: true,
    },
    loading: {
      // ok
      type: Boolean,
      default: false,
      required: true,
    },
    currentEditAddress: {
      // ok
      type: String,
      default: '',
      required: true,
    },
    currentEditDesc: {
      // ok
      type: String,
      default: '',
      required: true,
    },
    currentTypeIndex: {
      type: Number,
      default: 0,
      required: true,
    },
    buildingNameVal: {
      type: String,
      default: '',
      required: true,
    },
    houseNumberVal: {
      type: String,
      default: '',
      required: true,
    },
    aid: {
      default: '',
      required: true,
    },
    currentAid: {
      default: '',
      required: true,
    },
    addressType: {
      type: Array,
    },
    SFNoAddress: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      userInfo: ({ common }) => common.userInfo,
    }),
    isBillLading() {
      return this.typeName === 'billLading';
    },
    isShowRightIcon() {
      if (this.SFNoAddress) return false;
      return this.isBillLading
    }
  },
  data() {
    return {
      alertType: '',
      alertTitle: '',
      alertShowIcon: false,
      showAlertTips: false,
      isFirstShowTips: false,
      buildingNameVals: this.buildingNameVal,
      houseNumberVals: this.houseNumberVal,
      firstName: '',
      lastName: '',
      phone: '',
      isShowNoNumber: false,
      callingCode: '',
    };
  },
  watch: {
    isEdit: {
      handler() {
        if (this.isBillLading) {
          this.firstName = this.userInfo?.firstName;
          this.lastName = this.userInfo?.lastName;
          this.phone = this.userInfo?.phone;
          this.callingCode = this.userInfo?.callingCode;
        }
        this.isFirstShowTips = false;
        this.showAlertTips = false;
        this.buildingNameVals = this.buildingNameVal;
        this.houseNumberVals = this.houseNumberVal;
      },
      immediate: true,
    },
    buildingNameVals(newV) {
      this.$emit('update:buildingNameVal', newV);
    },
    houseNumberVals(newV) {
      this.$emit('update:houseNumberVal', newV);
    },
  },
  methods: {
    ...mapActions('common', ['setUserInfo']),
    clickCurrentType(typeIndex) {
      this.$emit('clickCurrentType', typeIndex);
    },
    // 修改区号
    changeCalling() {
      // +号不能删除，其余能删除，只能输入数字
      if (this.callingCode.length < 0) {
        this.callingCode = '+';
      } else {
        this.callingCode = '+' + this.callingCode.replace(/[^\d]/g, '');
      }
    },
    // 如果失去焦点
    blurCalling() {
      if (this.callingCode === '+') {
        this.callingCode = this.userInfo?.callingCode;
      }
    },
    // 选择去地址页面选择
    checkSelectPage() {
      // 如果是SF则不进入地址选择页面
      if (this.SFNoAddress) return;
      // 如果是配餐页面
      if (!this.isBillLading) return;
      this.$emit('selectAddressPage');
    },
    delAddress() {
      if (this.aid == this.currentAid) {
        this.showAlertTips = true;
        this.alertType = 'error';
        this.alertTitle = this.$t('不能删除这个地址');
        this.alertShowIcon = true;
        return;
      }
      this.$emit('delAddress');
    },
    createAddress() {
      if (this.isBillLading && !this.phone) {
        // 如果是提单页面的编辑，没有手机号，
        this.isShowNoNumber = true;
        let deliverPosition = document.querySelector('.phone-class');
        // block 定位 end center start nearest
        deliverPosition.scrollIntoView({
          block: 'center',
          behavior: 'smooth',
        });
        return;
      }
      if (this.phone) this.isShowNoNumber = false;
      if (
        !this.houseNumberVals &&
        !this.buildingNameVals &&
        !this.isFirstShowTips
      ) {
        this.showAlertTips = true;
        this.alertType = 'success';
        this.alertTitle = this.$t(
          '添加大楼名称以及门牌号，可以帮助配送员更快找你的送餐位置'
        );
        this.alertShowIcon = true;
        this.isFirstShowTips = true;
        return;
      }
      this.isFirstShowTips = false;
      if (this.isBillLading) {
        if (this.isShowNoNumber) this.isShowNoNumber = false;
        this.setUserInfo({
          firstName: this.firstName,
          lastName: this.lastName,
          phone: this.phone,
          callingCode: this.callingCode,
        });
      }
      this.$emit('createAddress');
    },
  },
};
</script>
<style lang="scss" scoped>
.err-tips {
  font-family: 'Aspira Light';
  font-size: 12px;
  color: #ff4e45;
  font-weight: 200;
  padding-top: 4px;
}
.edit-address {
  height: 100%;
  display: flex;
  flex-direction: column;
  .map-box {
    height: 80px;
    background: #ccc;
  }
  .edit-infos {
    flex: 1;
    overflow-y: auto;
    padding: 24px;
    .infos-display_name {
      font-family: 'Aspira Medium';
      font-size: 18px;
      color: #000000;
      font-weight: 500;
      line-height: 22px;
      margin-bottom: 6px;
      align-items: center;
    }
    .infos-display_name-text {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      overflow: hidden;
      -webkit-box-orient: vertical;
    }
    .common-flex {
      display: flex;
      justify-content: space-between;
    }
    .infos-display_desc {
      line-height: 18px;
      font-size: 14px;
      color: #666666;
      font-weight: 200;
      margin-bottom: 10px;
      font-family: 'Aspira Light';
      margin-right: 16px;
    }

    .el-input {
      margin-bottom: 12px;
    }

    .infos-type {
      font-size: 14px;
      color: #000000;
      padding: 16px 0 12px;
      font-family: 'Aspira Medium';
      font-weight: 500;
    }
    .infos-type_text_content {
      display: flex;
      margin-bottom: 16px;
    }
    .infos-type_text {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100px;
      height: 32px;
      background-color: rgba(0, 0, 0, 0.05);
      border-radius: 4px;
      margin-right: 10px;
      font-size: 14px;
      color: #000000;
      text-align: center;
      font-weight: 200;
      font-family: 'Aspira Light';
    }
    .infos-type_text_active {
      @include font-color();
      @include act-tag-bg-color();
    }
  }
  .info-btn {
    height: 68px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 24px;
    // position: relative;
    // top: 10px;
    // border-top: 1px solid #e5e5e5;
    // width: 140px;
    .el-button--default {
      width: 140px;
    }
    // .is-dark {
    //   width: 110px;
    // }
  }
}
.phone-class {
  display: flex;
  border-radius: 4px;
  border: 1px solid #ccc;
  .el-input {
    margin-bottom: 0px !important;
    ::v-deep input {
      border: none !important;
    }
  }
  ::v-deep .el-input--suffix {
    input {
      border-radius: 0 4px 4px 0 !important;
    }
  }

  .calling-style {
    width: 66px;
  }
  .calling-style::v-deep .el-input__inner {
    background-color: #ebebeb;
    border-right: 0;
  }
}
.phone-class_err {
  border: 1px solid #ff4e45;
}
</style>
